import { render, staticRenderFns } from "./PageProductsUpdate.vue?vue&type=template&id=7085caa6&scoped=true&"
import script from "./PageProductsUpdate.vue?vue&type=script&lang=ts&"
export * from "./PageProductsUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PageProductsUpdate.vue?vue&type=style&index=0&id=7085caa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7085caa6",
  null
  
)

export default component.exports